import _ from 'lodash';
import { buildSearchData } from './search-query';

const update_search = _.debounce(() => {
    const q = $('.auction-search-box').eq(0).val();
    const filters = [];
    $('.search-filter').each((i, el) => {
        const $el = $(el);
        const filter = $el.data('filter');
        if (!filter || !$el.is(':checked')) {
            return;
        }
        filters.push({ name: el.name, value: filter });
    });
    $('#auction-list').empty().html('<div class="text-center"><div class="lds-facebook"><div></div><div></div><div></div></div></div>');
    Rails.ajax({
        url: '/lots.js',
        type: 'GET',
        data: buildSearchData(q, filters)
    })
}, 300);

$(() => {
    $('.auction-search-box').on('keyup', update_search);
    $('.search-filter').each((i, el) => {
        $(el).on('change', update_search);
    });
    var currentXhr;
    currentXhr = null;

    $(document).on('ajax:send', function(_event, xhr) {
        if (currentXhr) {
            currentXhr.abort();
        }
        currentXhr = xhr;
        return true;
    });
    $(document).on('ajax:complete', function(_event, _xhr, _status) {
        currentXhr = null;
    });
    window.update_search = update_search;
});